module.exports = __webpack_public_path__ + "static/img/ryzs2ab.18e546ed.png";